import { render, staticRenderFns } from "./ChangePriceJustificationForm.vue?vue&type=template&id=68777d5a&scoped=true&"
import script from "./ChangePriceJustificationForm.vue?vue&type=script&lang=js&"
export * from "./ChangePriceJustificationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68777d5a",
  null
  
)

export default component.exports